import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * @module dyPublish 发布到抖音
 * @desc 发布视频/图片到抖音
*/
import dyJsBridge from '../../biz/jsBridge/dy';
import ATM from '../../util/atm';
import { getGameId } from '../login/common';

var getPublishParams = function getPublishParams(params) {
  var appId = params.appId,
      title = params.title,
      imageUrl = params.imageUrl,
      videoUrl = params.videoUrl,
      imageUrlList = params.imageUrlList,
      extraParams = params.extraParams,
      callback = params.callback;
  var signParams = {
    client_key: appId
  };

  var shareParams = _objectSpread({
    title: title,
    image_path: imageUrl,
    video_path: videoUrl || '',
    image_list_path: imageUrlList
  }, extraParams);

  return {
    signParams: signParams,
    shareParams: shareParams,
    callback: callback
  };
};

export default {
  /**
     * @method publish
     * @desc 发布视频/图片到抖音
     * @param {Object} params
     * @param params.appId - 应用ID，抖音的client_key，默认腾讯游戏的appid
     * @param params.title - 发布标题
     * @param params.imageUrl - 图片地址(单张图片),支持png/jpg
     * @param params.videoUrl - 视频地址，比图片优先级高，支持MP4/mov
     * @param params.imageUrlList - 多张图片数组
     * @param params.extraParams - 其他参数(参数名称保持和抖音开平一致)
     * @param params.callback - 回调函数
     *
    */
  publish: function publish(params) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _getPublishParams, shareParams, signParams, callback, _yield$dyJsBridge$sha, isOK, errMsg;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              try {
                ATM.reportATM({
                  toappid: 38,
                  tomoduletype: 22,
                  tointer: 3,
                  // douyin分享
                  businesstype: getGameId(),
                  toreturncode: 0,
                  result: 0,
                  cgi: location.href,
                  errormsg: 'douyin share publish',
                  serialtime: parseInt(new Date().getTime() / 1000)
                });
              } catch (error) {
                console.log(error);
              }

              _getPublishParams = getPublishParams(params), shareParams = _getPublishParams.shareParams, signParams = _getPublishParams.signParams, callback = _getPublishParams.callback;
              _context.next = 4;
              return dyJsBridge.share({
                signParams: signParams,
                shareParams: shareParams
              });

            case 4:
              _yield$dyJsBridge$sha = _context.sent;
              isOK = _yield$dyJsBridge$sha.isOK;
              errMsg = _yield$dyJsBridge$sha.errMsg;

              if (isOK) {
                _context.next = 10;
                break;
              }

              callback && callback({
                success: false,
                errMsg: errMsg
              });
              return _context.abrupt("return", {
                success: false,
                errMsg: errMsg
              });

            case 10:
              callback && callback({
                success: true
              });
              return _context.abrupt("return", {
                success: true
              });

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  getPublishSchema: function getPublishSchema(params) {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _getPublishParams2, shareParams, signParams, callback, _yield$dyJsBridge$get, isOK, sSchemaLink;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              try {
                ATM.reportATM({
                  toappid: 38,
                  tomoduletype: 22,
                  tointer: 3,
                  // msdk分享
                  businesstype: getGameId(),
                  toreturncode: 0,
                  result: 0,
                  cgi: location.href,
                  errormsg: 'douyin share getPublishSchema',
                  serialtime: parseInt(new Date().getTime() / 1000)
                });
              } catch (error) {
                console.log(error);
              }

              _getPublishParams2 = getPublishParams(params), shareParams = _getPublishParams2.shareParams, signParams = _getPublishParams2.signParams, callback = _getPublishParams2.callback;
              console.log('shareParams:', shareParams);
              _context2.next = 5;
              return dyJsBridge.getShareSchema({
                signParams: signParams,
                shareParams: shareParams
              });

            case 5:
              _yield$dyJsBridge$get = _context2.sent;
              isOK = _yield$dyJsBridge$get.isOK;
              sSchemaLink = _yield$dyJsBridge$get.sSchemaLink;

              if (isOK) {
                _context2.next = 11;
                break;
              }

              callback && callback({
                success: false,
                errMsg: '获取分享链接失败'
              });
              return _context2.abrupt("return", {
                success: false,
                errMsg: '获取分享链接失败'
              });

            case 11:
              callback && callback({
                success: true,
                sSchemaLink: sSchemaLink
              });
              return _context2.abrupt("return", {
                success: true,
                sSchemaLink: sSchemaLink
              });

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};